import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
    <footer className="bg-[#111111] text-white py-24 border-t border-[#333]">
        <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-24">
                {/* Brand Column */}
                {/* Brand Column */}
                <div className="col-span-1 md:col-span-1 space-y-8">
                    <Link to="/" className="block w-fit">
                        <h5 className="font-bold text-2xl tracking-tighter text-white hover:opacity-80 transition-opacity">Particle Simulator</h5>
                    </Link>
                    <p className="text-gray-400 text-sm leading-relaxed">
                        An interactive particle physics learning platform. Explore real experiments and learn by doing.
                    </p>
                    <div className="flex items-center gap-2 text-xs font-mono text-white border border-white/20 bg-white/5 px-3 py-1.5 rounded-full w-fit">
                        <div className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" />
                        FREE & OPEN SOURCE
                    </div>
                </div>

                {/* Platform Column */}
                <div>
                    <h6 className="font-bold text-sm uppercase tracking-widest text-gray-500 mb-6">Platform</h6>
                    <ul className="space-y-4 text-sm text-gray-300">
                        <li><Link to="/simulator" className="hover:text-white transition-colors">Launch Simulator</Link></li>
                        <li><Link to="/learn" className="hover:text-white transition-colors">Learn</Link></li>
                        <li><Link to="/team" className="hover:text-white transition-colors">Team</Link></li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-[#333] pt-12 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500">
                <p>&copy; 2026 Particle Simulator. Open source educational project.</p>
            </div>
        </div>
    </footer>
);

export default Footer;
